module.exports = __webpack_public_path__ + "img/751-174f40.png";